import * as React from 'react';
import ParameterResult from "./ParameterResult";
import BestResult from "./BestResult";
import { Parameters, VolumetricParameter, FlowParameter, PFTResults, DiffusingCapacityParameter, PressureParameter, StudyRelevantParameters } from './PFTAPITypes';
import ResultsGroupHeading from './ResultsGroupHeading';
import AverageResult from './AverageResult';

export interface PFTResultParametersProps {
    results: PFTResults;
    isLoading?: boolean;
    isRejected?: boolean;
    showConfiguredParametersOnly?: boolean;
    studyRelevantParameters?: StudyRelevantParameters;
    showBestParameters?: boolean;
    compareWithTestParameters?: boolean;
    showAverageParameters?: boolean
}

export const PFTResultParameters = ({ results, isLoading, isRejected, showConfiguredParametersOnly, studyRelevantParameters, showBestParameters = true, compareWithTestParameters = false, showAverageParameters = false }: PFTResultParametersProps) => {
    const renderBestValueResult = (parameter: VolumetricParameter | FlowParameter | DiffusingCapacityParameter | PressureParameter) => {
        const bestValue = results.BestParameters?.find(br => br.ParameterType === parameter.ParameterType && br.Units === parameter.Units);

        if (bestValue != null) {
            return <BestResult isLoading={isLoading} result={bestValue} />
        } else {
            return <td>-</td>;
        }
    }

    const renderAverageValueResult = (parameter: VolumetricParameter | FlowParameter | DiffusingCapacityParameter | PressureParameter) => {
        const average = results.ParametersAverages?.find(br => br.ParameterType === parameter.ParameterType && br.Units === parameter.Units);

        if (average) {
            return <AverageResult isLoading={isLoading} result={average} />
        } else {
            return <td>-</td>;
        }
    }
    let parameters: Parameters;
    if (showConfiguredParametersOnly) {
        parameters = studyRelevantParameters.AnalysisParameters ?? studyRelevantParameters.DefaultAnalysisParameters;
    } else {
        parameters = results.DisplayParameters;
        if (compareWithTestParameters) {
            parameters = parameters.filter(dp => results.TestResults.map(t => t.TestParameters).some(tp => tp.some(p => p.Identifier === dp.Identifier)));
        }
    }

    const isTestRejected = (overreaderAcceptability?: boolean, technicianAcceptability?: boolean) => {
        if (overreaderAcceptability === true) {
            return false;
        }
        if (overreaderAcceptability === false) {
            return true;
        }
        if (technicianAcceptability === true) {
            return false;
        }
        return true;
    }

    return (
        <>
            <ResultsGroupHeading resultsCount={results.TestResults.length} title="Parameters" />

            {
                parameters.map(dp => {

                    return (
                        <tr key={`DisplayedParameter${dp.ParameterType}_${dp.Units}`}>
                            <td>{dp.DisplayName}</td>
                            {
                                results.TestResults.sort((a, b) => a.TestNumber - b.TestNumber).map((tr, trIndex) => {
                                    return <ParameterResult
                                        key={`Result_${dp.ParameterType}_${dp.Units}_${tr.TestId}`}
                                        results={results.TestResults}
                                        isRejected={isTestRejected(tr.OverreaderAcceptability, tr.TechnicianAcceptability)}
                                        testIndex={trIndex}
                                        testNumber={tr.TestNumber}
                                        parameterId={dp.ParameterType}
                                        units={dp.Units}
                                        automationSection='parameters'
                                    />
                                })
                            }
                            {showBestParameters ? renderBestValueResult(dp) : null}
                            {showAverageParameters ? renderAverageValueResult(dp) : null}
                        </tr>
                    )
                })
            }
        </>
    );
}
